import React, {useEffect, useState} from 'react';
import {Spin} from 'antd';
import './mask-loading.scss';

interface MaskLoadingProps {
    loading: boolean;
}

const MaskLoading: React.FC<MaskLoadingProps> = (props) => {
    const {loading} = props;
    const [contentLoading, setContentLoading] = useState(false);

    useEffect(() => {
        let timeout: NodeJS.Timeout | undefined;
        if (loading) {
            timeout = setTimeout(() => {
                timeout = undefined;
                setContentLoading(true);
            }, 200);
        } else {
            setContentLoading(false);
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            setContentLoading(false);
        };
    }, [loading]);

    return (
        <div className={`maskLoadingContainer ${loading ? 'visible' : ''}`}>
            <div className={`content ${contentLoading ? 'visible' : ''}`}>
                <Spin />
            </div>
        </div>
    );
};

export default MaskLoading;
